import React from "react";
import { useParams } from "react-router-dom";
import Page404 from "../ErrorsPage/404";
import { usePropertyStore } from "../../../stores/PropertyStore";
import { BathSVG, BedSVG, CalendarSVG, CallIncomingSVG, CheckStrokeSVG, GarageSVG, LikeStrokeSVG, MailSVG, PriceSVG, PropertySVG, R360SVG, RoomSVG, ShareSVG, SqFtSVG, StarStrokeSVG, StarSVG } from "../../SVG";
import NearYouSection from "../PropertiesPage/NearYouSection";
import PropertyCard from "../PropertiesPage/PropertyCard";

function ViewPropertyPage() {
  const id = parseInt(useParams().id);
  const getProperties = usePropertyStore((state) => state.properties);

  if (isNaN(id)) return <Page404 />

  const property = getProperties.filter((property) => property.id === id)[0];

  return (
    <>
      <section className="flat-title ">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner style-detail">
                <div className="title-group fs-12">
                  <a className="home fw-6 text-color-3" href="/">
                    Accueil
                  </a>
                  <a className=" fw-5 text-color-3" href="/properties">
                    Liste des biens
                  </a>
                  <span>{property.name} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="flat-slider01">
        <div className="container-full">
          <div className="row">
            <div className="col-lg-12">
              <div className="swiper-container thumbs-swiper-column">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="image-detail">
                      <img
                        src="/assets/images/slider/slider-detail-1.jpg"
                        alt="images"
                      />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="image-detail">
                      <img
                        src="/assets/images/slider/slider-detail-12.jpg"
                        alt="images"
                      />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="image-detail">
                      <img
                        src="/assets/images/slider/slider-detail-13.jpg"
                        alt="images"
                      />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="image-detail">
                      <img
                        src="/assets/images/slider/slider-detail-14.jpg"
                        alt="images"
                      />
                    </div>
                  </div>
                </div>
                <div className="button-custom-slider">
                  <div className="swiper-button-next5">
                    <i className="far fa-chevron-down" />
                  </div>
                  <div className="swiper-button-prev5">
                    <i className="far fa-chevron-up" />
                  </div>
                </div>
              </div>
              <div
                thumbsslider=""
                className="swiper-container thumbs-swiper-column1 swiper-pagination5"
              >
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="image-detail">
                      <img
                        src="/assets/images/slider/slider-pagi-4.jpg"
                        alt="images"
                      />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="image-detail">
                      <img
                        src="/assets/images/slider/slider-pagi-1.jpg"
                        alt="images"
                      />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="image-detail">
                      <img
                        src="/assets/images/slider/slider-pagi-2.jpg"
                        alt="images"
                      />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="image-detail">
                      <img
                        src="/assets/images/slider/slider-pagi-3.jpg"
                        alt="images"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="flat-property-detail style2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="wrap-house wg-dream flex bg-white">
                <div className="box-1">
                  <div className="title-heading fs-30 fw-7 lh-45">
                    {property.name}
                  </div>
                  <div className="inner flex">
                    {property.isSponsored && (
                      <div className="sales fs-12 fw-7 font-2 text-color-1">
                        Sponsorisé
                      </div>
                    )}
                    <div className="text-address">
                      <p>{property.address}</p>
                    </div>
                    <div className="icon-inner flex">
                      <div className="years-icon flex align-center">
                        <i className="fal fa-calendar" />
                        <p className="text-color-2">
                          {property.publicationDate}
                        </p>
                      </div>
                      {/*TODO VIEWS <div className="view-icon flex align-center">
                          <i className="far fa-eye" />
                          <p className="text-color-2">4.529 Views</p>
                        </div> */}
                    </div>
                  </div>
                  <div className="icon-box flex">
                    <div className="icons icon-1 flex">
                      <span>Lits: </span>
                      <span className="fw-6">4</span>
                    </div>
                    <div className="icons icon-2 flex">
                      <span>Douches: </span>
                      <span className="fw-6">2</span>
                    </div>
                    <div className="icons icon-3 flex">
                      <span>Superficie: </span>
                      <span className="fw-6">1150</span>
                    </div>
                  </div>
                </div>
                <div className="box-2 text-end">
                  <div className="icon-boxs flex justify-content-end">
                    <a href="#">
                      <LikeStrokeSVG />
                    </a>
                    <a href="#">
                      <ShareSVG />
                    </a>
                  </div>
                  <div className="moneys fs-30 fw-7 lh-45 text-color-3">
                    €{property.price}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="post">
                <div className="wrap-overview wrap-style">
                  <h3 className="titles">Aperçu</h3>
                  <div className="icon-wrap flex">
                    <div className="box-icon">
                      <div className="inner flex">
                        <div className="icon">
                          <RoomSVG />
                        </div>
                        <div className="content">
                          <div className="font-2">Pièces</div>
                          <div className="font-2 fw-7">8</div>
                        </div>
                      </div>
                      <div className="inner flex">
                        <div className="icon">
                          <CalendarSVG />
                        </div>
                        <div className="content">
                          <div className="font-2">Construit en :</div>
                          <div className="font-2 fw-7">2023</div>
                        </div>
                      </div>
                    </div>
                    <div className="box-icon">
                      <div className="inner flex">
                        <div className="icon">
                          <BathSVG />
                        </div>
                        <div className="content">
                          <div className="font-2">Douches :</div>
                          <div className="font-2 fw-7">4</div>
                        </div>
                      </div>
                      <div className="inner flex">
                        <div className="icon">
                          <PropertySVG />
                        </div>
                        <div className="content">
                          <div className="font-2">Type de propriété :</div>
                          <div className="font-2 fw-7">Villa</div>
                        </div>
                      </div>
                    </div>
                    <div className="box-icon">
                      <div className="inner flex">
                        <div className="icon">
                          <BedSVG />
                        </div>
                        <div className="content">
                          <div className="font-2">Chambres :</div>
                          <div className="font-2 fw-7">4</div>
                        </div>
                      </div>
                      <div className="inner flex">
                        <div className="icon">
                          <GarageSVG />
                        </div>
                        <div className="content">
                          <div className="font-2">Garage :</div>
                          <div className="font-2 fw-7">1</div>
                        </div>
                      </div>
                    </div>
                    <div className="box-icon">
                      <div className="inner flex">
                        <div className="icon">
                          <SqFtSVG />
                        </div>
                        <div className="content">
                          <div className="font-2">Superficie :</div>
                          <div className="font-2 fw-7">53 m²</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="wrap-text wrap-style">
                  <h3 className="titles">Description de la propriété</h3>
                  <p className="text-1 text-color-2">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aliquam risus leo, blandit vitae diam a, vestibulum
                    viverra nisi. Vestibulum ullamcorper velit eget mattis
                    aliquam. Proin dapibus luctus pulvinar. Integer et libero
                    ut purus bibendum gravida non ac tellus. Proin sed tellus
                    porttitor, varius mauris vitae, tincidunt augue. Sed
                    consectetur magna elit, sit amet faucibus tortor sodales
                    vitae. Maecenas quis arcu est. Nam sit amet neque
                    vestibulum, fringilla elit sit amet, volutpat nunc.
                  </p>
                  <p className="text-2 text-color-2">
                    Aliquam non lorem consequat, luctus dui et, auctor nisi.
                    Aenean placerat sapien at augue lacinia, non semper urna
                    tempor. Mauris sit amet elit orci.
                  </p>
                  <a href="#" className="fw-6">
                    Voir plus
                  </a>
                </div>

                <div className="wrap-property wrap-style">
                  <h3 className="titles">Détails de la propriété</h3>
                  <div className="box flex">
                    <ul>
                      <li className="flex">
                        <span className="one fw-6">ID</span>
                        <span className="two">#1234</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Prix</span>
                        <span className="two">$7,500</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Superficie</span>
                        <span className="two">150 sqft</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Pièces</span>
                        <span className="two">9</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Douches</span>
                        <span className="two">3</span>
                      </li>
                    </ul>
                    <ul>
                      <li className="flex">
                        <span className="one fw-6">Chambres</span>
                        <span className="two">7.328</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Année de construction</span>
                        <span className="two">2022</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Type</span>
                        <span className="two">Villa</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Statut</span>
                        <span className="two">À vendre</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Garage</span>
                        <span className="two">1</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="wrap-featured wrap-style tf-amenities">
                  <h3 className="titles">En vedette</h3>
                  <div className="box-featured flex">
                    <div className="inner-1">
                      <div className="subtitle title-1 fw-6">Extérieur</div>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Piscine</span>
                      </label>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Balcon</span>
                      </label>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Parking couvert</span>
                      </label>
                    </div>
                    <div className="inner-2">
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Court de tennis</span>
                      </label>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Garage</span>
                      </label>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Espace extérieur</span>
                      </label>
                    </div>
                    <div className="inner-3">
                      <div className="subtitle title-1 fw-6">Intérieur</div>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Salle de bain attenante</span>
                      </label>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Bureau</span>
                      </label>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Système d'alarme</span>
                      </label>
                    </div>
                    <div className="inner-4">
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Lave-vaisselle</span>
                      </label>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Placards intégrés</span>
                      </label>
                      <label className="flex">
                        <input name="newsletter" type="checkbox" defaultChecked="" />
                        <span className="btn-checkbox" />
                        <span className="fs-13">Internet haut débit</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="wrap-map wrap-property wrap-style">
                  <h3 className="titles">Map location</h3>
                  <div className="box flex">
                    <ul>
                      <li className="flex">
                        <span className="one fw-6">Adresse</span>
                        <span className="two">150 m²</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Ville</span>
                        <span className="two">#1234</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">État / Département</span>
                        <span className="two">$7,500</span>
                      </li>
                    </ul>
                    <ul>
                      <li className="flex">
                        <span className="one fw-6">Code postal</span>
                        <span className="two">7.328</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Zone</span>
                        <span className="two">7.328</span>
                      </li>
                      <li className="flex">
                        <span className="one fw-6">Pays</span>
                        <span className="two">2022</span>
                      </li>
                    </ul>
                  </div>

                  <iframe title="map"
                    className="map-content"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7302.453092836291!2d90.47477022812872!3d23.77494577893369!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1svi!2s!4v1627293157601!5m2!1svi!2s"
                    allowFullScreen=""
                    loading="lazy"
                  />
                </div>
                <div className="wrap-floor wrap-property wrap-style">
                  <h3 className="titles">Plans d'étage</h3>
                  <div className="flat-accordion fl-faq-content">
                    <div className="flat-toggle">
                      <div className="toggle-title active flex justify-space">
                        <div className="btn-toggle" />
                        <div className="fw-6">Premier étage</div>
                        <div className="icon-box flex wg-dream">
                          <div className="icons icon-money flex">
                            <span>
                              <PriceSVG />
                            </span>{" "}
                            <span className="fw-6">Prix : </span>
                            <span>$7,500</span>
                          </div>
                          <div className="icons icon-3 flex">
                            <span className="fw-6">Superficie : </span>
                            <span>4</span>
                          </div>
                          <div className="icons icon-1 flex">
                            <span className="fw-6">Chambres : </span>
                            <span>150 m²</span>
                          </div>
                          <div className="icons icon-2 flex">
                            <span className="fw-6">Douches : </span>
                            <span>2</span>
                          </div>
                        </div>
                      </div>
                      <div className="toggle-content section-desc">
                        <img
                          src="/assets/images/img-box/property-5.jpg"
                          alt=""
                        />
                        <div className="title fw-6">Description :</div>
                        <p className="texts text-color-2">
                          Proin sed tellus porttitor, varius mauris vitae, tincidunt augue. Sed consectetur magna elit, sit amet faucibus tortor sodales vitae. Maecenas quis arcu est. Nam sit amet neque vestibulum, fringilla elit sit amet, volutpat nunc.
                        </p>
                        <p className="text-color-2">
                          Aliquam non lorem consequat, luctus dui et, auctor nisi. Aenean placerat sapien at augue lacinia, non semper urna tempor. Mauris sit amet elit orci.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flat-accordion fl-faq-content">
                    <div className="flat-toggle">
                      <div className="toggle-title flex justify-space">
                        <div className="btn-toggle" />
                        <div className="fw-6">Second étage</div>
                        <div className="icon-box flex wg-dream">
                          <div className="icons icon-money flex">
                            <span>
                              <PriceSVG />
                            </span>{" "}
                            <span className="fw-6">Prix : </span>
                            <span>$7,500</span>
                          </div>
                          <div className="icons icon-3 flex">
                            <span className="fw-6">Superficie : </span>
                            <span>4</span>
                          </div>
                          <div className="icons icon-1 flex">
                            <span className="fw-6">Chambres : </span>
                            <span>150 m²</span>
                          </div>
                          <div className="icons icon-2 flex">
                            <span className="fw-6">Douches : </span>
                            <span>2</span>
                          </div>
                        </div>
                      </div>
                      <div className="toggle-content section-desc">
                        <img
                          src="/assets/images/img-box/property-5.jpg"
                          alt=""
                        />
                        <div className="title fw-6">Description :</div>
                        <p className="texts text-color-2">
                          Proin sed tellus porttitor, varius mauris vitae, tincidunt augue. Sed consectetur magna elit, sit amet faucibus tortor sodales vitae. Maecenas quis arcu est. Nam sit amet neque vestibulum, fringilla elit sit amet, volutpat nunc.
                        </p>
                        <p className="text-color-2">
                          Aliquam non lorem consequat, luctus dui et, auctor nisi. Aenean placerat sapien at augue lacinia, non semper urna tempor. Mauris sit amet elit orci.
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div id="sidemenu" className="col-lg-4">
              <aside className="side-bar side-bar-1">
                <div className="inner-side-bar">
                  <div className="widget-tour widget-rent">
                    <h3 className="title-tour">Planifier une visite</h3>
                   
                    <h5>Type de visite</h5>
                    <div className="flat-tabs style2">
                      <div className="box-tab center">
                        <ul className="menu-tab tab-title flex">
                          <li className="item-title active flex align-center">
                            <CheckStrokeSVG />
                            <h4 className="inner">En personne</h4>
                          </li>
                          <li className="item-title style btn-1">
                            <h4 className="inner">Visio</h4>
                          </li>
                        </ul>
                      </div>
                      <div className="content-tab">
                        <div className="content-inner tab-content">
                          <div className="comments">
                            <div className="comment-form">
                              <form method="post">
                                <div className="wd-find-select">
                                  <div className="group-select">
                                    <div className="nice-select" tabIndex={0}>
                                      <span className="current">
                                        Choisissez l'heure
                                      </span>
                                      <ul className="list">
                                        <li
                                          data-value=""
                                          className="option selected"
                                        >
                                          Choisissez l'heure
                                        </li>
                                        <li data-value={6} className="option">
                                          6h
                                        </li>
                                        <li data-value={8} className="option">
                                          8h
                                        </li>
                                        <li
                                          data-value={10}
                                          className="option"
                                        >
                                          10h
                                        </li>
                                        <li
                                          data-value={14}
                                          className="option"
                                        >
                                          14h
                                        </li>
                                        <li
                                          data-value={16}
                                          className="option"
                                        >
                                          16h
                                        </li>
                                        <li
                                          data-value={18}
                                          className="option"
                                        >
                                          18h
                                        </li>
                                        <li
                                          data-value={20}
                                          className="option"
                                        >
                                          20h
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <fieldset className="">
                                    <input
                                      type="text"
                                      className=""
                                      name="text"
                                      placeholder="Votre nom"
                                      required=""
                                    />
                                  </fieldset>
                                  <fieldset className="">
                                    <input
                                      type="tel"
                                      className=""
                                      name="tel"
                                      placeholder="Numéro de téléphone"
                                      required=""
                                    />
                                  </fieldset>
                                  <fieldset className="">
                                    <input
                                      type="email"
                                      className=""
                                      name="email"
                                      placeholder="Adresse e-mail"
                                      required=""
                                    />
                                  </fieldset>
                                  <fieldset className="message-wrap">
                                    <textarea
                                      name="message"
                                      rows={4}
                                      tabIndex={4}
                                      placeholder="Votre message"
                                      defaultValue={""}
                                    />
                                  </fieldset>
                                  <div className="widget-form flex">
                                    <label className="widget-form">
                                      <input type="checkbox" />
                                      <span className="btn-checkbox flex-two" />
                                    </label>
                                    <div className="flex fs-13 lh-18">
                                      <span className="sub-title">
                                        J'accepte les
                                      </span>
                                      <a
                                        href="#"
                                        className="font-2 text-color-3 text-line"
                                      >
                                        {" "}
                                        Conditions Générales.
                                      </a>
                                    </div>
                                  </div>
                                  <div className="button-box center">
                                    <button className="sc-button btn-icon2 one btn-svg center">
                                      <span className="">
                                        Soumettre la demande
                                      </span>
                                      <svg
                                        width={18}
                                        height={10}
                                        viewBox="0 0 14 7"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M10.5 1L13 3.5M13 3.5L10.5 6M13 3.5H1"
                                          stroke="#fff"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="widget-rent style">
                    <h3 className="widget-title title-contact">
                      Contacter le vendeur
                    </h3>
                    <div className="author-box flex align-center">
                      <div className="image-author flex-none">
                        <img
                          src="/assets/images/author/author-footer.jpg"
                          alt="images"
                        />
                      </div>
                      <div className="content">
                        <p className="text-color-2">Antoine Silver</p>
                        <h5 className="link-style-1">
                          <a href="tel:0123456789">555-555-555</a>
                        </h5>
                        <a
                          className="fs-12 lh-18"
                          href="mailto:as.antoinesilver@gmail.com"
                        >
                          as.antoinesilver@gmail.com
                        </a>
                      </div>
                    </div>
                    <div className="comments">
                      <div className="comment-form">
                        <form method="post">
                          <div className="wd-find-select">
                            <fieldset className="">
                              <input
                                type="text"
                                className=""
                                name="text"
                                placeholder="Nom complet *"
                                required=""
                              />
                            </fieldset>
                            <fieldset className="">
                              <input
                                type="tel"
                                className=""
                                name="tel"
                                placeholder="Numéro de téléphone *"
                                required=""
                              />
                            </fieldset>
                            <fieldset className="">
                              <input
                                type="email"
                                className=""
                                name="email"
                                placeholder="Adresse e-mail"
                                required=""
                              />
                            </fieldset>
                            <fieldset className="message-wrap">
                              <textarea
                                name="message"
                                rows={4}
                                tabIndex={4}
                                placeholder="Votre message *"
                                defaultValue={""}
                              />
                            </fieldset>
                            <div className="button-box sc-btn-top center flex justify-center">
                              <button className="sc-button btn-svg">
                                <span>Envoyer</span>
                                <MailSVG />
                              </button>
                              <a
                                className="sc-button btn-1 btn-svg"
                                href="tel:012345678"
                              >
                                <span>Appeler</span>
                                <CallIncomingSVG />
                              </a>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <NearYouSection />
                </div>
              </aside>
            </div>

          </div>
          <div className="row py-sm-5 center justify-content-between">
            <div className="col-5-8 wrap-video wrap-style">
              <h3 className="titles">Video</h3>
              <div className="video-box center ">
                <div className="post-video flex align-center justify-center  relative">
                  <img
                    className="img-2"
                    src="/assets/images/img-box/property-video.jpg"
                    alt="images"
                  />
                  <a
                    href="https://youtu.be/MLpWrANjFbI"
                    className="lightbox-image"
                  >
                    <svg
                      width={11}
                      height={14}
                      viewBox="0 0 11 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 7L3.41715e-07 14L9.53674e-07 -4.80825e-07L11 7Z"
                        fill="#FFA920"
                      />
                    </svg>
                    <i className="ripple" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-5-8 wrap-virtual wrap-style">
              <h3 className="titles">Visite virtuel 360</h3>
              <div className="virtual-box relative flex align-center justify-center">
                <div className="images">
                  <img
                    className="img-2"
                    src="/assets/images/img-box/property-6.jpg"
                    alt="images"
                  />
                </div>
                <div className="icon absolute">
                  <R360SVG />
                </div>
              </div>
            </div>
          </div>

          <div className="row  justify-content-lg-between justify-content-md-center">

            <div className="wrap-review wrap-style col-lg-5-8">
            <div className="box-title titles flex align-center justify-space">
              <div className="inner flex align-center">
                <div className="star flex">
                  <StarSVG />
                </div>
                <h3>Avis</h3>
                <p className="fw-6">(27 avis)</p>
              </div>
            </div>
            <div className="comment-list">
              <ol className="">
                <li className="flex">
                  <div className="images flex-none">
                    <img
                      src="/assets/images/author/author-review-1.jpg"
                      alt="photo_de_l'auteur"
                    />
                  </div>
                  <div className="content">
                    <div className="title-item flex justify-space align-center">
                      <h4>Leslie Alexander</h4>
                      <p className="fs-12 lh-18">5 avril 2023</p>
                    </div>
                    <div className="star flex">
                      <StarSVG />
                      <StarSVG />
                      <StarSVG />
                      <StarStrokeSVG />
                      <StarStrokeSVG />
                    </div>
                    <p className="texts text-color-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit. Pellentesque at velit eu libero laoreet
                      mattis ac a ipsum. Vivamus efficitur volutpat
                      ante, sed consequat ligula ultricies in.
                    </p>
                  </div>
                  </li>
                  <li className="flex">
                    <div className="images flex-none">
                      <img
                        src="/assets/images/author/author-review-1.jpg"
                        alt="photo_de_l'auteur"
                      />
                    </div>
                    <div className="content">
                      <div className="title-item flex justify-space align-center">
                        <h4>Leslie Alexander</h4>
                        <p className="fs-12 lh-18">5 avril 2023</p>
                      </div>
                      <div className="star flex">
                        <StarSVG />
                        <StarSVG />
                        <StarSVG />
                        <StarStrokeSVG />
                        <StarStrokeSVG />
                      </div>
                      <p className="texts text-color-2">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit. Pellentesque at velit eu libero laoreet
                        mattis ac a ipsum. Vivamus efficitur volutpat
                        ante, sed consequat ligula ultricies in.
                      </p>
                    </div>
                  </li>
                  <li className="flex">
                    <div className="images flex-none">
                      <img
                        src="/assets/images/author/author-review-1.jpg"
                        alt="photo_de_l'auteur"
                      />
                    </div>
                    <div className="content">
                      <div className="title-item flex justify-space align-center">
                        <h4>Leslie Alexander</h4>
                        <p className="fs-12 lh-18">5 avril 2023</p>
                      </div>
                      <div className="star flex">
                        <StarSVG />
                        <StarSVG />
                        <StarSVG />
                        <StarStrokeSVG />
                        <StarStrokeSVG />
                      </div>
                      <p className="texts text-color-2">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit. Pellentesque at velit eu libero laoreet
                        mattis ac a ipsum. Vivamus efficitur volutpat
                        ante, sed consequat ligula ultricies in.
                      </p>
                    </div>
                  </li>
                  <li className="flex">
                    <div className="images flex-none">
                      <img
                        src="/assets/images/author/author-review-1.jpg"
                        alt="photo_de_l'auteur"
                      />
                    </div>
                    <div className="content">
                      <div className="title-item flex justify-space align-center">
                        <h4>Leslie Alexander</h4>
                        <p className="fs-12 lh-18">5 avril 2023</p>
                      </div>
                      <div className="star flex">
                        <StarSVG />
                        <StarSVG />
                        <StarSVG />
                        <StarStrokeSVG />
                        <StarStrokeSVG />
                      </div>
                      <p className="texts text-color-2">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit. Pellentesque at velit eu libero laoreet
                        mattis ac a ipsum. Vivamus efficitur volutpat
                        ante, sed consequat ligula ultricies in.
                      </p>
                    </div>
                  </li>
                {/* Ajoutez d'autres avis ici si nécessaire */}
              </ol>
            </div>
          </div>

            <div className="wrap-contact wrap-form wrap-style col-lg-5-8 m-sm-4 m-lg-0">
            <div className="titles">
              <h3>Laissez un avis</h3>
              <p className="fs-12 lh-18">
                Votre adresse e-mail ne sera pas publiée. Les champs obligatoires sont marqués *
              </p>
            </div>
            <div id="comments" className="comments">
              <div className="respond-comment">
                <form
                  method="post"
                  id="contactform"
                  className="comment-form form-submit"
                  action="https://themesflat.co/html/dreamhomehtml/contact/contact-process.php"
                  acceptCharset="utf-8"
                  noValidate="novalidate"
                >
                  <fieldset className="">
                    <label className="fw-6">Votre nom *</label>
                    <input
                      type="text"
                      className="my-input"
                      name="text"
                      placeholder="Votre nom"
                      required=""
                    />
                  </fieldset>
                  <div className="inner-1 form-wg flex">
                    <fieldset className="wg-box ">
                      <label className="fw-6">Adresse e-mail</label>
                      <input
                        type="email"
                        className="my-input"
                        name="email"
                        placeholder="Votre e-mail"
                        required=""
                      />
                    </fieldset>
                    <fieldset className="wg-box ">
                      <label className="fw-6">Numéro de téléphone</label>
                      <input
                        type="tel"
                        className="my-input2"
                        name="tel"
                        placeholder="Votre téléphone"
                        required=""
                      />
                    </fieldset>
                  </div>
                  <fieldset className="message-wrap">
                    <label className="fw-6">Votre avis</label>
                    <textarea
                      id="comment-message"
                      name="message"
                      rows={4}
                      tabIndex={4}
                      placeholder="Votre message"
                      aria-required="true"
                      defaultValue={""}
                    />
                  </fieldset>
                  <div className="inner-2 align-center flex">
                    <div className="title-rating font-2 fs-16 fw-8">
                      Évaluation
                    </div>
                    <div className="star flex">
                      <a className="star flex">
                        <StarStrokeSVG />
                        <StarStrokeSVG />
                        <StarStrokeSVG />
                        <StarStrokeSVG />
                        <StarStrokeSVG />
                      </a>
                    </div>
                  </div>
                  <button
                    className="sc-button"
                    name="submit"
                    type="submit"
                  >
                    <span>Envoyer l'avis</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
          </div>

        </div>

      </section>
      <section className="flat-sale-detail flat-sale wg-dream wg-dots tf-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="heading-section ">
                <div className="title-heading fs-30 lh-45 fw-7">
                  Propriétés en vedette
                </div>
                <p className="text-color-4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Integer vel lobortis justo
                </p>
              </div>
              <div className="swiper-container2">
                <div className="one-carousel owl-carousel owl-theme">
                  {getProperties.filter(p => p.isSponsored).map((p) => {
                    return <div className="slide-item swiper-slide" key={p.id}>
                      <PropertyCard property={p} />
                    </div>
                  })}

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
</>
  );
}

export default ViewPropertyPage;  
